module.exports = __webpack_public_path__ + "static/img/service_introduce_5114_zh_h5.f9cb665.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/service/service_introduce_5114_zh_h5.png
// module id = MExp
// module chunks = 34